// ./theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  // your theme options
  palette: {
    mode: "light",
    primary: {
      main: "#20948B",
    },
    secondary: {
      main: "#6AB187",
    },
  },
  shape: {
    borderRadius: 12,
  },
  spacing: 8,
});

export default theme;
